<template src="./template.html"></template>

<script>
import urlUtils from 'utils/urlUtils'
import config from 'src/config'
import authHelper from 'api/auth/helper'

export default {
  name: 'apple-wallet-button',
  props: {
    booking: {
      type: Object,
      required: true,
    },
    ticketId: {
      type: String,
      required: true,
    },
  },
  computed: {},
  data() {
    return {}
  },
  methods: {
    downloadFile() {
      const authToken = authHelper.getAuthToken()
      const prospectToken = authHelper.getProspectToken()

      let url = urlUtils.combinePaths(config.TABLELIST_API_BASE_URL, `/booking/${this.booking.id}/passbook?ticketId=${this.ticketId}`)

      if (this.booking.prospect) {
        url += `&prospect=${prospectToken}`
      } else if (authToken) {
        url += `&auth=${authToken}`
      }

      window.open(url)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/AppleWalletButton/index.vue